<script lang="ts">
import { kebabCase } from 'lodash-es'
import { defineComponent, h, resolveDirective, withDirectives } from 'vue'

export default defineComponent({
  inheritAttrs: false,
  props: {
    title: {
      type: Array as PropType<StoryBlokHeading>,
      required: true,
    },
  },
  setup({ title }, { attrs }) {
    if (title && title.length) {
      const editable = resolveDirective('editable')
      if (!editable) return () => false
      return () => withDirectives(h(`h${title[0].level}`, { ...attrs, id: title[0].anchor || kebabCase(title[0].text) }, title[0].text), [[editable, title[0]]])
    }
    return () => false
  },

})
</script>
